export enum BiteLogVerifonePointScaEvent {
  None = 0,
  Success = 1,
  TerminalRestarted = 2,
  SaleTransaction = 3,
  SaleTransactionError = 4,
  AuthenticationError = 5,
  PortError = 6,
  SyncTimeError = 7,
  KeyStoreError = 8,
  TerminalDisconnected = 9,
  CaptureTimeoutRecovery = 10,
  CaptureTimeoutGatewayStuck = 11,
  CaptureTimeoutSessionCleanupFailed = 12,
  CaptureTimeoutPaymentRecovered = 13,
  StartSessionBusyRecovery = 14,
}
